export class NumberFormat {
  static LOCALE = 'es-ar';
  static LOCALE_FORMAT = new Intl.NumberFormat(NumberFormat.LOCALE);

  /**
   * Formatea el número que recibe con separador cada 3 dígitos.
   * Devuelve el string resultante.
   */

  static formatNumber(input: number | undefined): string {
    if (input == null) return '';

    return this.LOCALE_FORMAT.format(input);
  }
}
